












































































































































































import Vue from 'vue'
import {mapActions, mapState, mapGetters} from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'
// costanti per gli interventi fitosanitari
import {
    INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI,
    INTERVENTO_FITOSANITARIO_MICOSI,
    INTERVENTO_ESEGUITO_POTATURA,
    INTERVENTO_ESEGUITO_FITOSANITARIO_MICOSI,
    INTERVENTO_ESEGUITO_FITOSANITARIO_DANNI_DA_INSETTI
} from '../../../costanti'

export default Vue.extend({
    data: () => ({
        urlPhoto: ''
    }),
    computed: {
        ...mapState('mapplantsMappa', ['rilevamentoMostrato']),
        ...mapGetters('auth', ['isAuthenticated']),
        // lo stato indicato dal censimento per quanto riguarda i danni da insetto
        statoInterventoDanniDaInsetto() {
            return this.rilevamentoMostrato.interventi_fitosanitari.includes(INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI) ? 'Necessario' : 'Non necessario'
        },
        // lo stato indicato dal censimento per quanto riguarda la micosi
        statoInterventoMicosi() {
            return this.rilevamentoMostrato.interventi_fitosanitari.includes(INTERVENTO_FITOSANITARIO_MICOSI) ? 'Necessario' : 'Non necessario'
        },
        // gli interventi di potatura
        interventiPotatura() {
            return this.rilevamentoMostrato.interventi_eseguiti.filter(intervento => intervento.tipo_intervento.id === INTERVENTO_ESEGUITO_POTATURA)
        },
        // gli interventi per micosi
        interventiMicosi() {
            return this.rilevamentoMostrato.interventi_eseguiti.filter(intervento => intervento.tipo_intervento.id === INTERVENTO_ESEGUITO_FITOSANITARIO_MICOSI)
        },
        // gli interventi per danni da insetto
        interventiDanniDaInsetto() {
            return this.rilevamentoMostrato.interventi_eseguiti.filter(intervento => intervento.tipo_intervento.id === INTERVENTO_ESEGUITO_FITOSANITARIO_DANNI_DA_INSETTI)
        },
        // gli altri tipi di intervento
        interventiAltro() {
            return this.rilevamentoMostrato.interventi_eseguiti.filter(
                intervento => intervento.tipo_intervento.id !== INTERVENTO_ESEGUITO_POTATURA &&
                    intervento.tipo_intervento.id !== INTERVENTO_FITOSANITARIO_MICOSI &&
                    intervento.tipo_intervento.id !== INTERVENTO_FITOSANITARIO_DANNI_DA_INSETTI)
        }
    },
    watch: {
        rilevamentoMostrato(newValue) {
            // load photo
            this.loadPhotoUrl(newValue.specie)
        }
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        async loadPhotoUrl(specie) {
            this.urlPhoto = (await Vue.axios.get(`/api_mapplants/foto_piante.json?specie=${specie}`)).data[0].url_foto
        },
        dataParsata: (data) => moment(data).format('DD MMMM YYYY')
    },
    mounted() {
        // date italiane
        moment.locale('it')
    }
})
